function geometricProps(barNodes, i) {

    //Coordenadas dos nós
    var lx1 = barNodes[i][0]
    var ly1 = barNodes[i][1]
    var lx2 = barNodes[i][3]
    var ly2 = barNodes[i][4]

    var L = (((lx2-lx1)**2)+((ly2-ly1)**2))**(0.5) //Comprimento da barra
    var cs = (lx2-lx1)/L                            //cosseno
    var sn = (ly2-ly1)/L                            //seno

    return ({L, cs, sn})
}

export default geometricProps